import { cva } from 'class-variance-authority';

export const CurrencyVariant = cva('font-normal', {
  variants: {
    size: {
      sm: 'text-xs mt-2 leading-[15px] font-skyBook',
      md: 'text-xl leading-5 font-skyBlack',
      lg: 'text-xl leading-5 font-skyBlack',
      xl: '',
      xxl: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export const IntegralPriceVariant = cva('font-normal font-skyBlack', {
  variants: {
    size: {
      sm: 'text-6xl leading-[43.2px]',
      md: 'text-12xl leading-[120%] font-markProBlack font-black',
      lg: 'text-16xl leading-[44.8px]',
      xl: '',
      xxl: 'text-[64px] leading-[72px]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export const DecimalPriceVariant = cva('font-normal', {
  variants: {
    size: {
      sm: 'text-base leading-[19.2px] font-skyBook',
      md: 'text-xl leading-[120%] font-markPro',
      lg: 'text-xl leading-5 font-skyBlack',
      xl: '',
      xxl: 'text-[24px] leading-[36px] font-markPro font-bold',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export const OriginalPriceVariant = cva('font-skyBook font-normal line-through', {
  variants: {
    size: {
      sm: 'text-xs leading-[15px]',
      md: 'text-sm leading-[17.5px]',
      lg: 'text-sm leading-[17.5px]',
      xl: '',
      xxl: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export const PriceBlockVariant = cva('font-skyBook font-normal', {
  variants: {
    size: {
      sm: 'text-xs leading-[15px]',
      md: 'text-sm leading-[17.5px]',
      lg: 'text-xl leading-[24px]',
      xl: '',
      xxl: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export const PriceFrequencyVariant = cva('font-skyBook font-normal', {
  variants: {
    size: {
      sm: 'text-xs leading-[15px]',
      md: 'text-base leading-[125%] font-markPro',
      lg: 'text-sm leading-[17.5px]',
      xl: '',
      xxl: 'text-[24px] leading-[36px] font-markPro font-normal text-neutral-light-grey',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
